"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isItemClickable = exports.isDisabledCheckbox = void 0;
var isItemClickable = exports.isItemClickable = function isItemClickable(item, isMaxSelectableReached, itemsAreReady) {
  var loading = item.loading,
    sizeError = item.sizeError,
    fetchError = item.fetchError,
    aspectRatioError = item.aspectRatioError,
    checked = item.checked;
  // easier to corroborate the opposite
  var isUnclickable = loading || sizeError || fetchError || aspectRatioError || !checked && isMaxSelectableReached || !itemsAreReady;
  return !isUnclickable;
};
var isDisabledCheckbox = exports.isDisabledCheckbox = function isDisabledCheckbox(item, isMaxSelectableReached) {
  var sizeError = item.sizeError,
    fetchError = item.fetchError,
    aspectRatioError = item.aspectRatioError,
    checked = item.checked;
  var isDisabled = !sizeError && !fetchError && !aspectRatioError && !checked && isMaxSelectableReached;
  return isDisabled;
};